export * from './hot-ones-card';
